import { Component, OnInit } from '@angular/core';
import * as  moment from 'moment';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { SharedService } from 'app/modules/common/services/shared-service';
import { ActuationService } from 'app/modules/employee-view/services/actuation.service';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-comentariopopup',
    templateUrl: './comentariopopup.component.html',
    styleUrls: ['./comentariopopup.component.scss'],
    standalone: false
})
export class ComentariopopupComponent implements OnInit {

  ComentarioFormGroup: UntypedFormGroup;
  actuation: any;

  constructor(
    private fb: UntypedFormBuilder,
    private sharedService: SharedService,
    private actuationService: ActuationService,
    public dialogRef: MatDialogRef<ComentariopopupComponent>,
    public snackBar: MatSnackBar
  ) { }


  ngOnInit(): void {
    this.InitForm();
  }

  InitForm(): void {
    const today = moment();
    this.ComentarioFormGroup = this.fb.group({
      Employee: this.fb.group({
        EmployeeId: ['', Validators.required],
        LeaveId: ['', Validators.required]
      }),
      Gestion: this.fb.group({
        TipoAutor: ['C'],
        Type: [''],
        Date: [today],
        Autor: [this.sharedService.getCurrentUser().coordinador],
        Comments: [''],
        Interno: [false]
      })
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }

  Crate(): void {
    this.ComentarioFormGroup.get(['Employee', 'EmployeeId']).setValue(this.actuation.trabajadorId);
    this.ComentarioFormGroup.get(['Employee', 'LeaveId']).setValue(this.actuation.bajaId);
      this.ComentarioFormGroup.get(['Gestion', 'Type']).setValue(29999);

    this.actuationService.createCommentario(this.ComentarioFormGroup.getRawValue()).subscribe(res => {
      if (res.code === 0) {
        this.ShowSnackBar("Actualizado exitosamente", "Okay", 2500);
        
        this.dialogRef.close();
      } else {
        this.ShowSnackBar("Ocurrió un error", "Okay", 2500);
      }
    }, err => {
      console.error(err);
    })
  }

  public ShowSnackBar(message: string, action: string, duration: number) {
    return this.snackBar.open(message, action, {
      duration: duration
    });
  }

}
